import { configReducer } from '../../store/config/config.reducer';
import { footerReducer } from '../../store/footer/footer.reducer';
import {
    getAdSlots,
    getCategory, getDfpProperty,
    getHeaderBidderPublisherID,
    getLanguage,
    getSiteName,
    getPageType,
} from '../../store/config/config.selectors';
import {
    getArticleId,
    getBlockNames,
    getChannels,
    getCommercialTags,
    getContentTypesToQuantity,
    getCover,
    getCreatedAt,
    getDfpCategory, getNumberOfWordsTyped, getOwnerName,
    getTags,
    getTitle,
} from '../../store/template/postPage/postPage.selectors';
import { postPageReducer } from '../../store/template/postPage/postPage.reducer';
import { TemplateRegistration } from '../templateRegistration';
import { AppState } from '../../store/initialStateRegistration';
import {
    getPageDataEvent, injectArticleBlockByIndexArrayEvent,
    injectButtonToFooterLinksSectionEvent, injectButtonToMenuEvent,
    injectVideoLogoEvent,
} from '../../client/clientAPI/events';
import { formatDate, getCountryCode, getCoverType } from '../templates.utils';
import { headerWithSubMenusReducer } from '../../store/headerWithSubMenus/headerWithSubMenus.reducer';
import { PostPageWithRecommendationsAdvertisementComponent } from './PostPageWithRecommendationsAdvertisementComponent';

export const rootReducer = {
    config: configReducer,
    footer: footerReducer,
    headerWithSubMenus: headerWithSubMenusReducer,
    template: postPageReducer,
};

const getCoreParams = (state: AppState) => ({
    property: getSiteName(state),
    language: getLanguage(state),
    category: getCategory(state),
    pageType: getPageType(state),
    adSlots: getAdSlots(state),
    headerBidderPublisherID: getHeaderBidderPublisherID(state),
    articleId: getArticleId(state),
    articleTemplate: getBlockNames(state),
    channels: getChannels(state),
    articleAuthor: getOwnerName(state),
    articleTitle: getTitle(state),
    articlePublicationTime: formatDate(getCreatedAt(state)),
    contentTags: getTags(state),
    mainMedia: getCoverType(getCover(state)),
    countryCode: getCountryCode(),
    commercialTags: getCommercialTags(state),
    dfpCategory: getDfpCategory(state),
    articleContentCount: getContentTypesToQuantity(state),
    articleWordCount: getNumberOfWordsTyped(state),
    dfpProperty: getDfpProperty(state),
});

export const PostPageWithRecommendationsAdvertisement = new TemplateRegistration()
    .setComponent(PostPageWithRecommendationsAdvertisementComponent)
    .setRootReducer(rootReducer)
    .setCoreParams(getCoreParams)
    .addClientAPIEvent(injectVideoLogoEvent)
    .addClientAPIEvent(getPageDataEvent)
    .addClientAPIEvent(injectArticleBlockByIndexArrayEvent)
    .addClientAPIEvent(injectButtonToFooterLinksSectionEvent)
    .addClientAPIEvent(injectButtonToMenuEvent)
    .build();
